import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, take, tap } from 'rxjs/operators';
import { DsModalService, DsModalVariant } from '@levelaccess/design-system';
import { AiChatService } from './ai-chat.service';
import { AiChatInstrumentationService } from './ai-chat-instrumentation.service';
import { DsConfirmationModalComponent } from '../ds-confirmation-modal/ds-confirmation-modal.component';
import { TranslateService } from '../../translate/translate.service';
import { NotificationService } from '../../services/notification.service';
import { NotificationPosition } from '../../models/notification.model';

@Injectable({ providedIn: 'root' })
export class AiChatDeleteService {
  constructor(
    private dsModalService: DsModalService,
    private translateService: TranslateService,
    private aiChatService: AiChatService,
    private notificationService: NotificationService,
    private aiChatInstrumentationService: AiChatInstrumentationService,
  ) {}

  confirmAndDeleteSession(sessionId: string, triggerElement?: HTMLElement): Observable<void> {
    const modalRef = this.dsModalService.open(DsConfirmationModalComponent, DsModalVariant.center);
    const modal: DsConfirmationModalComponent = modalRef.componentInstance as DsConfirmationModalComponent;
    modal.title = this.translateService.instant('delete_chat_session_confirmation_title');
    modal.description = this.translateService.instant('delete_chat_session_confirmation_message');
    modal.confirmLabel = this.translateService.instant('action_delete');
    modal.closeAllModals = false;
    modal.maxWidthPercentage = 40;

    let wasConfirmed = false;
    modalRef?.hidden?.pipe(take(1)).subscribe((): void => {
      if (!wasConfirmed) {
        triggerElement?.focus();
      }
    });

    return modal.confirm.pipe(
      take(1),
      tap((): void => {
        wasConfirmed = true;
      }),
      switchMap((): Observable<void> => this.aiChatService.deleteChatSession(sessionId)),
      tap((): void => this.aiChatInstrumentationService.sendDeleteEvent(sessionId)),
      catchError((): typeof EMPTY => {
        this.notificationService.error(
          this.translateService.instant('error_action_cant_be_performed'),
          NotificationPosition.Toast,
          true,
        );
        return EMPTY;
      }),
    );
  }
}
